// extracted by mini-css-extract-plugin
module.exports = {"tableWrapper":"styles_tableWrapper__1FNUY","col":"styles_col__vXOEM"};